export type WebUIEnvironments = 'dev' | 'qa' | 'prod'
const { host, pathname } = window.location;

const USER_LOCALE = window.navigator.language;

const isDev = host.indexOf('localhost') > -1;

// look for a url like localhost/certifyapp_mpare, which is used for jumpbox debugging
const isJumpboxDebugPath = isDev && pathname.toLowerCase().indexOf('certifyapp_') > -1;

const isQA = host.indexOf('qa.') > -1;
const isProd = host.indexOf('expense.') > -1;


const getWebUIEnvironment = (): WebUIEnvironments => {
    if (isProd) {
        return 'prod'
    }
    
    if (isQA) {
        return 'qa'
    }

    return 'dev'
}

/* 
    if debugging on the jumpbox set root path like:
        /certifyapp_user/
*/
const ROOT_PATH = isJumpboxDebugPath ? `/${pathname.split('/')[1]}/` : '/';

const rootRelativeUrl = function (path: string): string {
    return ROOT_PATH + path;
};

const userTimezoneString = new Date().toLocaleTimeString(undefined,{timeZoneName:'short'}).split(' ')[2];

export {
    isDev,
    isJumpboxDebugPath,
    isQA,
    isProd,
    getWebUIEnvironment,
    ROOT_PATH,
    USER_LOCALE,
    rootRelativeUrl,
    userTimezoneString,
};